import isClient from 'commons/isClient';
import { logError } from './logger';

function decodeBase64(txt) {
  try {
    const str = txt
      ? txt.replace(/[-_,]/gi, x => {
          if (x === '-') return '+';
          if (x === '_') return '/';
          if (x === ',') return '=';
          return x;
        })
      : '';

    if (isClient()) {
      return window.atob(str);
    }
    return Buffer.from(str, 'base64').toString('binary');
  } catch (e) {
    logError(e);
    return '';
  }
}

export default decodeBase64;
